import { Controller } from "@hotwired/stimulus"

/**
 * Validation des médias de story à la sélection (avant upload) :
 * - image ≤ 5 Mo
 * - vidéo ≤ 10 Mo et ≤ 30 s
 * - audio ≤ 5 Mo et ≤ 30 s
 * Miroir des validations serveur de StorySlide — évite d'envoyer
 * un fichier voué à être rejeté. Les messages (traduits) sont
 * fournis par la vue via les values Stimulus.
 */
const MAX_IMAGE_BYTES = 5 * 1024 * 1024
const MAX_VIDEO_BYTES = 10 * 1024 * 1024
const MAX_AUDIO_BYTES = 5 * 1024 * 1024
const MAX_MEDIA_SECONDS = 30

export default class extends Controller {
  static values = {
    imageTooLargeMessage: String,
    videoTooLargeMessage: String,
    videoTooLongMessage: String,
    audioTooLargeMessage: String,
    audioTooLongMessage: String,
  }

  validate(event) {
    const file = event.target.files[0]
    if (!file) return

    if (file.type.startsWith("image/")) {
      this.checkSize(event, file, MAX_IMAGE_BYTES,
        this.imageTooLargeMessageValue)
    } else if (file.type.startsWith("video/")) {
      if (this.checkSize(event, file, MAX_VIDEO_BYTES,
        this.videoTooLargeMessageValue)) return
      this.checkDuration(event, file, "video",
        this.videoTooLongMessageValue)
    } else if (file.type.startsWith("audio/")) {
      if (this.checkSize(event, file, MAX_AUDIO_BYTES,
        this.audioTooLargeMessageValue)) return
      this.checkDuration(event, file, "audio",
        this.audioTooLongMessageValue)
    }
  }

  // Returns true when the file was rejected.
  checkSize(event, file, maxBytes, message) {
    if (file.size <= maxBytes) return false

    this.reject(event, message)
    return true
  }

  checkDuration(event, file, tagName, message) {
    const media = document.createElement(tagName)
    media.preload = "metadata"

    media.onloadedmetadata = () => {
      window.URL.revokeObjectURL(media.src)
      // Certains conteneurs (WebM MediaRecorder) rapportent une
      // durée Infinity : on laisse passer plutôt que de rejeter
      // un fichier valide, le serveur tranchera.
      if (Number.isFinite(media.duration) &&
          media.duration > MAX_MEDIA_SECONDS) {
        this.reject(event, message)
      }
    }
    media.onerror = () => window.URL.revokeObjectURL(media.src)

    media.src = URL.createObjectURL(file)
  }

  reject(event, message) {
    // eslint-disable-next-line no-alert
    alert(message)
    event.target.value = ""
    // La prévisualisation (file-preview) écoute le même événement
    // change et a pu s'afficher avant ce rejet (cas asynchrone de
    // la durée) : on rejoue l'événement sur l'input vidé pour la
    // masquer, sinon l'UI laisse croire qu'un fichier est joint.
    event.target.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
